import PropTypes from 'prop-types';
import CarCompareTable from './CarCompareTable';
import CruiseCompareTable from './CruiseCompareTable';
import FlightCompareTable from './FlightCompareTable';
import HotelCompareTable from './HotelCompareTable';
import TourCompareTable from './TourCompareTable';

const CompareTable = ({
  cruiseTravelOptions,
  hotelTravelOptions,
  flightTravelOptions,
  carTravelOptions,
  tourTravelOptions,
  doShowViewButtonColumn,
  doShowLabelWithPrice,
  doShowPricing,
  hotelRateDisplayPreference,
  doShowHotelSourceInHotelName,
}) => {
  let cruiseCompareTable = '';
  let hotelCompareTable = '';
  let flightCompareTable = '';
  let carCompareTable = '';
  let tourCompareTable = '';
  const doShowPrice = doShowPricing;
  if (cruiseTravelOptions && cruiseTravelOptions.length) {
    cruiseCompareTable = (
      <CruiseCompareTable
        cruiseTravelOptions={cruiseTravelOptions}
        doShowViewButtonColumn={doShowViewButtonColumn}
        doShowLabelWithPrice={doShowLabelWithPrice}
        doShowPrice={doShowPrice}
      />
    );
  }
  if (hotelTravelOptions && hotelTravelOptions.length) {
    hotelCompareTable = (
      <HotelCompareTable
        hotelTravelOptions={hotelTravelOptions}
        doShowViewButtonColumn={doShowViewButtonColumn}
        doShowPrice={doShowPrice}
        hotelRateDisplayPreference={hotelRateDisplayPreference}
        doShowHotelSourceInHotelName={doShowHotelSourceInHotelName}
      />
    );
  }
  if (flightTravelOptions && flightTravelOptions.length) {
    flightCompareTable = (
      <FlightCompareTable
        flightTravelOptions={flightTravelOptions}
        doShowViewButtonColumn={doShowViewButtonColumn}
        doShowPrice={doShowPrice}
      />
    );
  }
  if (carTravelOptions && carTravelOptions.length) {
    carCompareTable = (
      <CarCompareTable
        carTravelOptions={carTravelOptions}
        doShowViewButtonColumn={doShowViewButtonColumn}
        doShowPrice={doShowPrice}
      />
    );
  }
  if (tourTravelOptions && tourTravelOptions.length) {
    tourCompareTable = (
      <TourCompareTable
        tourTravelOptions={tourTravelOptions}
        doShowViewButtonColumn={doShowViewButtonColumn}
        doShowPrice={doShowPrice}
      />
    );
  }
  return (
    <>
      {cruiseCompareTable}
      {hotelCompareTable}
      {flightCompareTable}
      {carCompareTable}
      {tourCompareTable}
    </>
  );
};

CompareTable.propTypes = {
  cruiseTravelOptions: PropTypes.arrayOf(PropTypes.objectOf),
  hotelTravelOptions: PropTypes.arrayOf(PropTypes.objectOf),
  flightTravelOptions: PropTypes.arrayOf(PropTypes.objectOf),
  carTravelOptions: PropTypes.arrayOf(PropTypes.objectOf),
  tourTravelOptions: PropTypes.arrayOf(PropTypes.objectOf),
  doShowViewButtonColumn: PropTypes.bool,
  doShowLabelWithPrice: PropTypes.bool,
  doShowPricing: PropTypes.bool,
  hotelRateDisplayPreference: PropTypes.number,
  doShowHotelSourceInHotelName: PropTypes.bool,
};

CompareTable.defaultProps = {
  doShowViewButtonColumn: true,
  doShowLabelWithPrice: true,
  doShowPricing: true,
  hotelTravelOptions: [],
  cruiseTravelOptions: [],
  flightTravelOptions: [],
  carTravelOptions: [],
  tourTravelOptions: [],
  hotelRateDisplayPreference: undefined,
  doShowHotelSourceInHotelName: undefined,
};
export default CompareTable;
